import React from 'react';
import { Redirect, useLocation, useParams } from 'react-router-dom';
import { string } from 'prop-types';

const LegacyRouteRedirect = ({ to }) => {
  const { kind, quickCode } = useParams();
  const { search } = useLocation();
  const target = to.replace(':kind', kind).replace(':quickCode', quickCode);
  return <Redirect to={`${target}${search || ''}`} />;
};

LegacyRouteRedirect.propTypes = {
  to: string.isRequired
};

export default LegacyRouteRedirect;
